import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Button, Input, Row, Col} from 'reactstrap'
import {getUserPermissions} from '../../utils/userPermissions'

const propTypes = {
  index: PropTypes.number.isRequired,
  comment: PropTypes.object.isRequired,
  toEdit: PropTypes.bool,
  showSaveBtn: PropTypes.bool.isRequired,
  onChangeFunction: PropTypes.func.isRequired,
  onSaveFunction: PropTypes.func.isRequired,
  onDestroyFunction: PropTypes.func.isRequired,
  onEditToggleFunction: PropTypes.func.isRequired,
}

const defaultProps = {
  comment: {},
  toEdit: false,
  showSaveBtn: true
}

class CommentBox extends Component {
  constructor() {
    super()
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  handleSubmit(e) {
    e.preventDefault()
    this.props.onSaveFunction(this.props.index)
    this.setState({toEdit: false})
  }

  renderEditOrShow(comment, index) {
    if (this.props.toEdit) {
      return (
        <div className="form-inline" style={{marginTop: index === 0 ? '5px' : '21px'}}>
          <Col md="11">
            <Input style={{width: '100%'}} type="textarea" name="comment" value={comment.comment}
              onChange={(e) => this.props.onChangeFunction(index, e.target.value)}/>
          </Col>
          <Col md="1" style={{textAlign: 'right', padding: '0px'}}>
            {this.props.showSaveBtn &&
            <Button size="sm" color="primary" title="Save" onClick={this.handleSubmit}><i className="fa fa-save"/></Button> }
            <Button size="sm" color="danger" title="Cancel" onClick={() => {
              comment.id ? this.props.onEditToggleFunction(index) : this.props.onDestroyFunction(index)
            }}><i className="fa fa-close"/></Button>
          </Col>
        </div>
      )
    } else {
      return (
        <Row>
          <Col md="11">
            <b>{comment.comment}</b>
          </Col>
          <Col md="1">
            {getUserPermissions('core.comments.destroy') &&
            <Button size="sm" color="danger" className="float-right" title="Remove" onClick={() => {
              this.props.onDestroyFunction(index)
            }}><i className="fa fa-trash-o"/></Button>}
            {getUserPermissions('core.comments.update') &&
            <Button size="sm" color="warning" className="float-right" title="Edit" onClick={() => {
              this.props.onEditToggleFunction(index)
            }}><i className="fa fa-edit"/></Button>}
          </Col>
        </Row>
      )
    }
  }

  render() {
    const {comment, index} = this.props
    return (
      <div>
        <div className="message">
          {!this.props.toEdit && <div>
            <small className="text-muted">{comment.id && comment.user.email}</small>
            <small className="text-muted float-right mt-1">{comment.updated_at}</small>
          </div>}
          {this.renderEditOrShow(comment, index)}
        </div>
        <hr/>
      </div>
    )
  }
}

CommentBox.propTypes = propTypes
CommentBox.defaultProps = defaultProps

export default CommentBox



// WEBPACK FOOTER //
// ./src/components/Comments/CommentBox.js